module.exports = {
  // 头部菜单
  header_menu: {
      logout: '退出' 
  }
}